import { api_url } from "../configiration/config";
import { axiosClone } from './../axiosClone';

//Services 
export async function getService(serviceSlug){
    return await axiosClone.get(`${api_url}/our-services/${serviceSlug}`);
  }
//get all services  
export async function getAllServices(){
    return await axiosClone.get(`${api_url}/our-services`);
}